import script from "./3d-effect.vue?vue&type=script&setup=true&lang=js"
export * from "./3d-effect.vue?vue&type=script&setup=true&lang=js"

import "./3d-effect.vue?vue&type=style&index=0&id=4fd8925d&lang=less"

const __exports__ = script;

export default __exports__